// Generated by scripts/write-augmented-war-replay-fixtures.ts.
// Do not edit manually.

import type { AugmentedWarState } from "@cloudnest/augmented-war-engine";
import type { AugmentedWarReplayEventType } from "./event-adapter";

export interface AugmentedWarReplayFixturePlayer {
  readonly id: string;
  readonly name: string;
  readonly role: "host" | "player";
}

export interface AugmentedWarReplayFixtureEvent {
  readonly sequenceNumber: number;
  readonly eventType: AugmentedWarReplayEventType;
  readonly userId: string;
  readonly payload: Record<string, unknown>;
}

export interface AugmentedWarReplayFixture {
  readonly schemaVersion: 1;
  readonly gameType: "augmented-war";
  readonly scenario: string;
  readonly source: "generated";
  readonly capturedAt: string;
  readonly players: readonly AugmentedWarReplayFixturePlayer[];
  readonly events: readonly AugmentedWarReplayFixtureEvent[];
  readonly notes: readonly string[];
}

/** The init event's payload is a full `AugmentedWarState` snapshot. */
export interface AugmentedWarReplayInitPayload {
  readonly state: AugmentedWarState;
}

export const AUGMENTED_WAR_REPLAY_FIXTURES: Record<
  string,
  AugmentedWarReplayFixture
> = {
  "simple-2p-live": {
    schemaVersion: 1,
    gameType: "augmented-war",
    scenario: "simple-2p-live",
    source: "generated",
    capturedAt: "2026-07-21T00:00:00.000Z",
    players: [
      {
        id: "p1",
        name: "P1",
        role: "player",
      },
      {
        id: "p2",
        name: "P2",
        role: "player",
      },
    ],
    events: [
      {
        sequenceNumber: 1,
        eventType: "init",
        userId: "p1",
        payload: {
          state: {
            gameId: "sim-3",
            phase: "PLAYING",
            board: {
              "-3,2": {
                owner: "p1",
                hp: 3,
              },
              "-2,2": {
                owner: "p1",
                hp: 3,
              },
              "-2,1": {
                owner: "p1",
                hp: 3,
              },
              "-1,2": {
                owner: "p1",
                hp: 3,
              },
              "3,-2": {
                owner: "p2",
                hp: 3,
              },
              "2,-2": {
                owner: "p2",
                hp: 3,
              },
              "2,-1": {
                owner: "p2",
                hp: 3,
              },
              "1,-2": {
                owner: "p2",
                hp: 3,
              },
              "-3,3": {
                owner: "p1",
                hp: 3,
              },
            },
            currentPlayerId: "p1",
            turn: 1,
            apRemaining: 2,
            actionsUsed: {
              move: 0,
              attack: 0,
              deploy: 0,
            },
            players: {
              p1: {
                faction: "beast",
                reserve: 5,
                spentElements: [],
                bastionAvailable: false,
              },
              p2: {
                faction: "beast",
                reserve: 6,
                spentElements: [],
                bastionAvailable: false,
              },
            },
          },
        },
      },
      {
        sequenceNumber: 2,
        eventType: "Deploy",
        userId: "p1",
        payload: {
          type: "Deploy",
          playerId: "p1",
          to: "-2,3",
        },
      },
      {
        sequenceNumber: 3,
        eventType: "Move",
        userId: "p1",
        payload: {
          type: "Move",
          playerId: "p1",
          from: "-2,1",
          to: "-1,0",
        },
      },
      {
        sequenceNumber: 4,
        eventType: "EndTurn",
        userId: "p1",
        payload: {
          type: "EndTurn",
          playerId: "p1",
        },
      },
      {
        sequenceNumber: 5,
        eventType: "Deploy",
        userId: "p2",
        payload: {
          type: "Deploy",
          playerId: "p2",
          to: "3,-3",
        },
      },
      {
        sequenceNumber: 6,
        eventType: "Move",
        userId: "p2",
        payload: {
          type: "Move",
          playerId: "p2",
          from: "2,-1",
          to: "1,0",
        },
      },
      {
        sequenceNumber: 7,
        eventType: "EndTurn",
        userId: "p2",
        payload: {
          type: "EndTurn",
          playerId: "p2",
        },
      },
      {
        sequenceNumber: 8,
        eventType: "Move",
        userId: "p1",
        payload: {
          type: "Move",
          playerId: "p1",
          from: "-1,0",
          to: "0,-1",
        },
      },
      {
        sequenceNumber: 9,
        eventType: "Move",
        userId: "p1",
        payload: {
          type: "Move",
          playerId: "p1",
          from: "0,-1",
          to: "0,-2",
        },
      },
      {
        sequenceNumber: 10,
        eventType: "EndTurn",
        userId: "p1",
        payload: {
          type: "EndTurn",
          playerId: "p1",
        },
      },
      {
        sequenceNumber: 11,
        eventType: "Deploy",
        userId: "p2",
        payload: {
          type: "Deploy",
          playerId: "p2",
          to: "2,-3",
        },
      },
      {
        sequenceNumber: 12,
        eventType: "Move",
        userId: "p2",
        payload: {
          type: "Move",
          playerId: "p2",
          from: "1,0",
          to: "0,1",
        },
      },
      {
        sequenceNumber: 13,
        eventType: "EndTurn",
        userId: "p2",
        payload: {
          type: "EndTurn",
          playerId: "p2",
        },
      },
      {
        sequenceNumber: 14,
        eventType: "Move",
        userId: "p1",
        payload: {
          type: "Move",
          playerId: "p1",
          from: "0,-2",
          to: "1,-3",
        },
      },
      {
        sequenceNumber: 15,
        eventType: "Attack",
        userId: "p1",
        payload: {
          type: "Attack",
          playerId: "p1",
          from: "1,-3",
          target: "2,-3",
          attackerElement: "fire",
          defenderElement: "water",
          advance: true,
          attackerUseBastion: false,
          defenderUseBastion: false,
        },
      },
      {
        sequenceNumber: 16,
        eventType: "EndTurn",
        userId: "p1",
        payload: {
          type: "EndTurn",
          playerId: "p1",
        },
      },
      {
        sequenceNumber: 17,
        eventType: "Attack",
        userId: "p2",
        payload: {
          type: "Attack",
          playerId: "p2",
          from: "0,1",
          target: "-1,2",
          attackerElement: "ice",
          defenderElement: "plant",
          advance: true,
          attackerUseBastion: false,
          defenderUseBastion: false,
        },
      },
      {
        sequenceNumber: 18,
        eventType: "Attack",
        userId: "p2",
        payload: {
          type: "Attack",
          playerId: "p2",
          from: "0,1",
          target: "-1,2",
          attackerElement: "plant",
          defenderElement: "water",
          advance: true,
          attackerUseBastion: false,
          defenderUseBastion: false,
        },
      },
      {
        sequenceNumber: 19,
        eventType: "EndTurn",
        userId: "p2",
        payload: {
          type: "EndTurn",
          playerId: "p2",
        },
      },
      {
        sequenceNumber: 20,
        eventType: "Attack",
        userId: "p1",
        payload: {
          type: "Attack",
          playerId: "p1",
          from: "1,-3",
          target: "2,-3",
          attackerElement: "water",
          defenderElement: "fire",
          advance: true,
          attackerUseBastion: false,
          defenderUseBastion: false,
        },
      },
      {
        sequenceNumber: 21,
        eventType: "Attack",
        userId: "p1",
        payload: {
          type: "Attack",
          playerId: "p1",
          from: "-1,2",
          target: "0,1",
          attackerElement: "plant",
          defenderElement: "stone",
          advance: true,
          attackerUseBastion: false,
          defenderUseBastion: false,
        },
      },
      {
        sequenceNumber: 22,
        eventType: "EndTurn",
        userId: "p1",
        payload: {
          type: "EndTurn",
          playerId: "p1",
        },
      },
      {
        sequenceNumber: 23,
        eventType: "Attack",
        userId: "p2",
        payload: {
          type: "Attack",
          playerId: "p2",
          from: "0,1",
          target: "-1,2",
          attackerElement: "stone",
          defenderElement: "ice",
          advance: true,
          attackerUseBastion: false,
          defenderUseBastion: false,
        },
      },
      {
        sequenceNumber: 24,
        eventType: "Attack",
        userId: "p2",
        payload: {
          type: "Attack",
          playerId: "p2",
          from: "-1,2",
          target: "-2,2",
          attackerElement: "water",
          defenderElement: "fire",
          advance: true,
          attackerUseBastion: false,
          defenderUseBastion: false,
        },
      },
      {
        sequenceNumber: 25,
        eventType: "EndTurn",
        userId: "p2",
        payload: {
          type: "EndTurn",
          playerId: "p2",
        },
      },
      {
        sequenceNumber: 26,
        eventType: "Attack",
        userId: "p1",
        payload: {
          type: "Attack",
          playerId: "p1",
          from: "-2,3",
          target: "-1,2",
          attackerElement: "fire",
          defenderElement: "plant",
          advance: true,
          attackerUseBastion: false,
          defenderUseBastion: false,
        },
      },
      {
        sequenceNumber: 27,
        eventType: "Attack",
        userId: "p1",
        payload: {
          type: "Attack",
          playerId: "p1",
          from: "-2,2",
          target: "-1,2",
          attackerElement: "stone",
          defenderElement: "ice",
          advance: true,
          attackerUseBastion: false,
          defenderUseBastion: false,
        },
      },
      {
        sequenceNumber: 28,
        eventType: "EndTurn",
        userId: "p1",
        payload: {
          type: "EndTurn",
          playerId: "p1",
        },
      },
      {
        sequenceNumber: 29,
        eventType: "Move",
        userId: "p2",
        payload: {
          type: "Move",
          playerId: "p2",
          from: "3,-2",
          to: "2,-1",
        },
      },
      {
        sequenceNumber: 30,
        eventType: "Move",
        userId: "p2",
        payload: {
          type: "Move",
          playerId: "p2",
          from: "2,-1",
          to: "1,0",
        },
      },
      {
        sequenceNumber: 31,
        eventType: "EndTurn",
        userId: "p2",
        payload: {
          type: "EndTurn",
          playerId: "p2",
        },
      },
      {
        sequenceNumber: 32,
        eventType: "Move",
        userId: "p1",
        payload: {
          type: "Move",
          playerId: "p1",
          from: "-1,2",
          to: "0,1",
        },
      },
      {
        sequenceNumber: 33,
        eventType: "Attack",
        userId: "p1",
        payload: {
          type: "Attack",
          playerId: "p1",
          from: "1,-3",
          target: "2,-3",
          attackerElement: "water",
          defenderElement: "stone",
          advance: true,
          attackerUseBastion: false,
          defenderUseBastion: false,
        },
      },
      {
        sequenceNumber: 34,
        eventType: "EndTurn",
        userId: "p1",
        payload: {
          type: "EndTurn",
          playerId: "p1",
        },
      },
      {
        sequenceNumber: 35,
        eventType: "Attack",
        userId: "p2",
        payload: {
          type: "Attack",
          playerId: "p2",
          from: "1,0",
          target: "0,1",
          attackerElement: "fire",
          defenderElement: "ice",
          advance: true,
          attackerUseBastion: false,
          defenderUseBastion: false,
        },
      },
      {
        sequenceNumber: 36,
        eventType: "Move",
        userId: "p2",
        payload: {
          type: "Move",
          playerId: "p2",
          from: "1,0",
          to: "1,1",
        },
      },
      {
        sequenceNumber: 37,
        eventType: "EndTurn",
        userId: "p2",
        payload: {
          type: "EndTurn",
          playerId: "p2",
        },
      },
      {
        sequenceNumber: 38,
        eventType: "Move",
        userId: "p1",
        payload: {
          type: "Move",
          playerId: "p1",
          from: "0,1",
          to: "-1,1",
        },
      },
      {
        sequenceNumber: 39,
        eventType: "Attack",
        userId: "p1",
        payload: {
          type: "Attack",
          playerId: "p1",
          from: "1,-3",
          target: "2,-3",
          attackerElement: "plant",
          defenderElement: "plant",
          advance: true,
          attackerUseBastion: false,
          defenderUseBastion: false,
        },
      },
      {
        sequenceNumber: 40,
        eventType: "EndTurn",
        userId: "p1",
        payload: {
          type: "EndTurn",
          playerId: "p1",
        },
      },
      {
        sequenceNumber: 41,
        eventType: "Move",
        userId: "p2",
        payload: {
          type: "Move",
          playerId: "p2",
          from: "1,1",
          to: "0,2",
        },
      },
      {
        sequenceNumber: 42,
        eventType: "Move",
        userId: "p2",
        payload: {
          type: "Move",
          playerId: "p2",
          from: "0,2",
          to: "-1,3",
        },
      },
      {
        sequenceNumber: 43,
        eventType: "EndTurn",
        userId: "p2",
        payload: {
          type: "EndTurn",
          playerId: "p2",
        },
      },
      {
        sequenceNumber: 44,
        eventType: "Attack",
        userId: "p1",
        payload: {
          type: "Attack",
          playerId: "p1",
          from: "1,-3",
          target: "2,-3",
          attackerElement: "fire",
          defenderElement: "fire",
          advance: true,
          attackerUseBastion: false,
          defenderUseBastion: false,
        },
      },
      {
        sequenceNumber: 45,
        eventType: "Move",
        userId: "p1",
        payload: {
          type: "Move",
          playerId: "p1",
          from: "-1,1",
          to: "-2,1",
        },
      },
      {
        sequenceNumber: 46,
        eventType: "EndTurn",
        userId: "p1",
        payload: {
          type: "EndTurn",
          playerId: "p1",
        },
      },
      {
        sequenceNumber: 47,
        eventType: "Attack",
        userId: "p2",
        payload: {
          type: "Attack",
          playerId: "p2",
          from: "-1,3",
          target: "-2,3",
          attackerElement: "ice",
          defenderElement: "plant",
          advance: true,
          attackerUseBastion: false,
          defenderUseBastion: false,
        },
      },
      {
        sequenceNumber: 48,
        eventType: "Attack",
        userId: "p2",
        payload: {
          type: "Attack",
          playerId: "p2",
          from: "-1,3",
          target: "-2,3",
          attackerElement: "plant",
          defenderElement: "water",
          advance: true,
          attackerUseBastion: false,
          defenderUseBastion: false,
        },
      },
      {
        sequenceNumber: 49,
        eventType: "EndTurn",
        userId: "p2",
        payload: {
          type: "EndTurn",
          playerId: "p2",
        },
      },
      {
        sequenceNumber: 50,
        eventType: "Attack",
        userId: "p1",
        payload: {
          type: "Attack",
          playerId: "p1",
          from: "1,-3",
          target: "2,-3",
          attackerElement: "water",
          defenderElement: "stone",
          advance: true,
          attackerUseBastion: false,
          defenderUseBastion: false,
        },
      },
    ],
    notes: [
      "Generated from the self-play sim: seed 3, greedy vs greedy.",
      "Result: breakthrough (p1) — 17 turns, 16 combats.",
    ],
  },
  "simple-2p-timeout": {
    schemaVersion: 1,
    gameType: "augmented-war",
    scenario: "simple-2p-timeout",
    source: "generated",
    capturedAt: "2026-07-21T00:00:00.000Z",
    players: [
      {
        id: "p1",
        name: "P1",
        role: "player",
      },
      {
        id: "p2",
        name: "P2",
        role: "player",
      },
    ],
    events: [
      {
        sequenceNumber: 1,
        eventType: "init",
        userId: "p1",
        payload: {
          state: {
            gameId: "sim-1",
            phase: "PLAYING",
            board: {
              "-3,2": {
                owner: "p1",
                hp: 3,
              },
              "-2,2": {
                owner: "p1",
                hp: 3,
              },
              "-2,1": {
                owner: "p1",
                hp: 3,
              },
              "-1,2": {
                owner: "p1",
                hp: 3,
              },
              "3,-2": {
                owner: "p2",
                hp: 3,
              },
              "2,-2": {
                owner: "p2",
                hp: 3,
              },
              "2,-1": {
                owner: "p2",
                hp: 3,
              },
              "1,-2": {
                owner: "p2",
                hp: 3,
              },
              "-3,3": {
                owner: "p1",
                hp: 3,
              },
            },
            currentPlayerId: "p1",
            turn: 1,
            apRemaining: 2,
            actionsUsed: {
              move: 0,
              attack: 0,
              deploy: 0,
            },
            players: {
              p1: {
                faction: "beast",
                reserve: 5,
                spentElements: [],
                bastionAvailable: false,
              },
              p2: {
                faction: "beast",
                reserve: 6,
                spentElements: [],
                bastionAvailable: false,
              },
            },
          },
        },
      },
      {
        sequenceNumber: 2,
        eventType: "Deploy",
        userId: "p1",
        payload: {
          type: "Deploy",
          playerId: "p1",
          to: "-2,3",
        },
      },
      {
        sequenceNumber: 3,
        eventType: "Move",
        userId: "p1",
        payload: {
          type: "Move",
          playerId: "p1",
          from: "-2,1",
          to: "-1,0",
        },
      },
      {
        sequenceNumber: 4,
        eventType: "EndTurn",
        userId: "p1",
        payload: {
          type: "EndTurn",
          playerId: "p1",
        },
      },
      {
        sequenceNumber: 5,
        eventType: "Deploy",
        userId: "p2",
        payload: {
          type: "Deploy",
          playerId: "p2",
          to: "2,-3",
        },
      },
      {
        sequenceNumber: 6,
        eventType: "Move",
        userId: "p2",
        payload: {
          type: "Move",
          playerId: "p2",
          from: "2,-1",
          to: "1,0",
        },
      },
      {
        sequenceNumber: 7,
        eventType: "EndTurn",
        userId: "p2",
        payload: {
          type: "EndTurn",
          playerId: "p2",
        },
      },
      {
        sequenceNumber: 8,
        eventType: "Move",
        userId: "p1",
        payload: {
          type: "Move",
          playerId: "p1",
          from: "-1,0",
          to: "0,-1",
        },
      },
      {
        sequenceNumber: 9,
        eventType: "Attack",
        userId: "p1",
        payload: {
          type: "Attack",
          playerId: "p1",
          from: "0,-1",
          target: "1,-2",
          attackerElement: "water",
          defenderElement: "plant",
          advance: true,
          attackerUseBastion: false,
          defenderUseBastion: false,
        },
      },
      {
        sequenceNumber: 10,
        eventType: "EndTurn",
        userId: "p1",
        payload: {
          type: "EndTurn",
          playerId: "p1",
        },
      },
      {
        sequenceNumber: 11,
        eventType: "Deploy",
        userId: "p2",
        payload: {
          type: "Deploy",
          playerId: "p2",
          to: "3,-3",
        },
      },
      {
        sequenceNumber: 12,
        eventType: "Move",
        userId: "p2",
        payload: {
          type: "Move",
          playerId: "p2",
          from: "1,0",
          to: "0,1",
        },
      },
      {
        sequenceNumber: 13,
        eventType: "EndTurn",
        userId: "p2",
        payload: {
          type: "EndTurn",
          playerId: "p2",
        },
      },
      {
        sequenceNumber: 14,
        eventType: "Move",
        userId: "p1",
        payload: {
          type: "Move",
          playerId: "p1",
          from: "-3,2",
          to: "-3,1",
        },
      },
      {
        sequenceNumber: 15,
        eventType: "Attack",
        userId: "p1",
        payload: {
          type: "Attack",
          playerId: "p1",
          from: "0,-1",
          target: "1,-2",
          attackerElement: "water",
          defenderElement: "fire",
          advance: true,
          attackerUseBastion: false,
          defenderUseBastion: false,
        },
      },
      {
        sequenceNumber: 16,
        eventType: "EndTurn",
        userId: "p1",
        payload: {
          type: "EndTurn",
          playerId: "p1",
        },
      },
      {
        sequenceNumber: 17,
        eventType: "Attack",
        userId: "p2",
        payload: {
          type: "Attack",
          playerId: "p2",
          from: "0,1",
          target: "-1,2",
          attackerElement: "stone",
          defenderElement: "plant",
          advance: true,
          attackerUseBastion: false,
          defenderUseBastion: false,
        },
      },
      {
        sequenceNumber: 18,
        eventType: "Move",
        userId: "p2",
        payload: {
          type: "Move",
          playerId: "p2",
          from: "2,-2",
          to: "1,-1",
        },
      },
      {
        sequenceNumber: 19,
        eventType: "EndTurn",
        userId: "p2",
        payload: {
          type: "EndTurn",
          playerId: "p2",
        },
      },
      {
        sequenceNumber: 20,
        eventType: "Attack",
        userId: "p1",
        payload: {
          type: "Attack",
          playerId: "p1",
          from: "0,-1",
          target: "1,-1",
          attackerElement: "fire",
          defenderElement: "water",
          advance: true,
          attackerUseBastion: false,
          defenderUseBastion: false,
        },
      },
      {
        sequenceNumber: 21,
        eventType: "Attack",
        userId: "p1",
        payload: {
          type: "Attack",
          playerId: "p1",
          from: "0,-1",
          target: "1,-2",
          attackerElement: "stone",
          defenderElement: "ice",
          advance: true,
          attackerUseBastion: false,
          defenderUseBastion: false,
        },
      },
      {
        sequenceNumber: 22,
        eventType: "EndTurn",
        userId: "p1",
        payload: {
          type: "EndTurn",
          playerId: "p1",
        },
      },
      {
        sequenceNumber: 23,
        eventType: "Attack",
        userId: "p2",
        payload: {
          type: "Attack",
          playerId: "p2",
          from: "1,-1",
          target: "0,-1",
          attackerElement: "ice",
          defenderElement: "plant",
          advance: true,
          attackerUseBastion: false,
          defenderUseBastion: false,
        },
      },
      {
        sequenceNumber: 24,
        eventType: "Attack",
        userId: "p2",
        payload: {
          type: "Attack",
          playerId: "p2",
          from: "0,1",
          target: "-1,2",
          attackerElement: "plant",
          defenderElement: "water",
          advance: true,
          attackerUseBastion: false,
          defenderUseBastion: false,
        },
      },
      {
        sequenceNumber: 25,
        eventType: "EndTurn",
        userId: "p2",
        payload: {
          type: "EndTurn",
          playerId: "p2",
        },
      },
      {
        sequenceNumber: 26,
        eventType: "Move",
        userId: "p1",
        payload: {
          type: "Move",
          playerId: "p1",
          from: "-2,2",
          to: "-2,1",
        },
      },
      {
        sequenceNumber: 27,
        eventType: "Move",
        userId: "p1",
        payload: {
          type: "Move",
          playerId: "p1",
          from: "-2,1",
          to: "-1,0",
        },
      },
      {
        sequenceNumber: 28,
        eventType: "EndTurn",
        userId: "p1",
        payload: {
          type: "EndTurn",
          playerId: "p1",
        },
      },
      {
        sequenceNumber: 29,
        eventType: "Move",
        userId: "p2",
        payload: {
          type: "Move",
          playerId: "p2",
          from: "0,1",
          to: "0,2",
        },
      },
      {
        sequenceNumber: 30,
        eventType: "Move",
        userId: "p2",
        payload: {
          type: "Move",
          playerId: "p2",
          from: "0,2",
          to: "-1,3",
        },
      },
      {
        sequenceNumber: 31,
        eventType: "EndTurn",
        userId: "p2",
        payload: {
          type: "EndTurn",
          playerId: "p2",
        },
      },
      {
        sequenceNumber: 32,
        eventType: "Attack",
        userId: "p1",
        payload: {
          type: "Attack",
          playerId: "p1",
          from: "-1,2",
          target: "-1,3",
          attackerElement: "plant",
          defenderElement: "stone",
          advance: true,
          attackerUseBastion: false,
          defenderUseBastion: false,
        },
      },
      {
        sequenceNumber: 33,
        eventType: "Attack",
        userId: "p1",
        payload: {
          type: "Attack",
          playerId: "p1",
          from: "-1,2",
          target: "-1,3",
          attackerElement: "ice",
          defenderElement: "water",
          advance: true,
          attackerUseBastion: false,
          defenderUseBastion: false,
        },
      },
      {
        sequenceNumber: 34,
        eventType: "EndTurn",
        userId: "p1",
        payload: {
          type: "EndTurn",
          playerId: "p1",
        },
      },
      {
        sequenceNumber: 35,
        eventType: "Attack",
        userId: "p2",
        payload: {
          type: "Attack",
          playerId: "p2",
          from: "0,-1",
          target: "-1,0",
          attackerElement: "water",
          defenderElement: "stone",
          advance: true,
          attackerUseBastion: false,
          defenderUseBastion: false,
        },
      },
      {
        sequenceNumber: 36,
        eventType: "Move",
        userId: "p2",
        payload: {
          type: "Move",
          playerId: "p2",
          from: "3,-3",
          to: "2,-2",
        },
      },
      {
        sequenceNumber: 37,
        eventType: "EndTurn",
        userId: "p2",
        payload: {
          type: "EndTurn",
          playerId: "p2",
        },
      },
      {
        sequenceNumber: 38,
        eventType: "Move",
        userId: "p1",
        payload: {
          type: "Move",
          playerId: "p1",
          from: "-3,1",
          to: "-2,1",
        },
      },
      {
        sequenceNumber: 39,
        eventType: "Attack",
        userId: "p1",
        payload: {
          type: "Attack",
          playerId: "p1",
          from: "-1,0",
          target: "0,-1",
          attackerElement: "fire",
          defenderElement: "stone",
          advance: true,
          attackerUseBastion: false,
          defenderUseBastion: false,
        },
      },
      {
        sequenceNumber: 40,
        eventType: "EndTurn",
        userId: "p1",
        payload: {
          type: "EndTurn",
          playerId: "p1",
        },
      },
      {
        sequenceNumber: 41,
        eventType: "Attack",
        userId: "p2",
        payload: {
          type: "Attack",
          playerId: "p2",
          from: "0,-1",
          target: "-1,0",
          attackerElement: "ice",
          defenderElement: "stone",
          advance: true,
          attackerUseBastion: false,
          defenderUseBastion: false,
        },
      },
      {
        sequenceNumber: 42,
        eventType: "Attack",
        userId: "p2",
        payload: {
          type: "Attack",
          playerId: "p2",
          from: "0,-1",
          target: "-1,0",
          attackerElement: "fire",
          defenderElement: "plant",
          advance: true,
          attackerUseBastion: false,
          defenderUseBastion: false,
        },
      },
      {
        sequenceNumber: 43,
        eventType: "EndTurn",
        userId: "p2",
        payload: {
          type: "EndTurn",
          playerId: "p2",
        },
      },
      {
        sequenceNumber: 44,
        eventType: "Move",
        userId: "p1",
        payload: {
          type: "Move",
          playerId: "p1",
          from: "-2,1",
          to: "-1,1",
        },
      },
      {
        sequenceNumber: 45,
        eventType: "Attack",
        userId: "p1",
        payload: {
          type: "Attack",
          playerId: "p1",
          from: "-1,1",
          target: "-1,0",
          attackerElement: "plant",
          defenderElement: "water",
          advance: true,
          attackerUseBastion: false,
          defenderUseBastion: false,
        },
      },
      {
        sequenceNumber: 46,
        eventType: "EndTurn",
        userId: "p1",
        payload: {
          type: "EndTurn",
          playerId: "p1",
        },
      },
      {
        sequenceNumber: 47,
        eventType: "Deploy",
        userId: "p2",
        payload: {
          type: "Deploy",
          playerId: "p2",
          to: "3,-3",
        },
      },
      {
        sequenceNumber: 48,
        eventType: "Move",
        userId: "p2",
        payload: {
          type: "Move",
          playerId: "p2",
          from: "-1,0",
          to: "-2,1",
        },
      },
      {
        sequenceNumber: 49,
        eventType: "EndTurn",
        userId: "p2",
        payload: {
          type: "EndTurn",
          playerId: "p2",
        },
      },
      {
        sequenceNumber: 50,
        eventType: "Attack",
        userId: "p1",
        payload: {
          type: "Attack",
          playerId: "p1",
          from: "-1,1",
          target: "-2,1",
          attackerElement: "fire",
          defenderElement: "water",
          advance: true,
          attackerUseBastion: false,
          defenderUseBastion: false,
        },
      },
      {
        sequenceNumber: 51,
        eventType: "Attack",
        userId: "p1",
        payload: {
          type: "Attack",
          playerId: "p1",
          from: "-1,1",
          target: "-2,1",
          attackerElement: "stone",
          defenderElement: "plant",
          advance: true,
          attackerUseBastion: false,
          defenderUseBastion: false,
        },
      },
      {
        sequenceNumber: 52,
        eventType: "EndTurn",
        userId: "p1",
        payload: {
          type: "EndTurn",
          playerId: "p1",
        },
      },
      {
        sequenceNumber: 53,
        eventType: "Attack",
        userId: "p2",
        payload: {
          type: "Attack",
          playerId: "p2",
          from: "-2,1",
          target: "-1,1",
          attackerElement: "ice",
          defenderElement: "ice",
          advance: true,
          attackerUseBastion: false,
          defenderUseBastion: false,
        },
      },
      {
        sequenceNumber: 54,
        eventType: "Move",
        userId: "p2",
        payload: {
          type: "Move",
          playerId: "p2",
          from: "-2,1",
          to: "-2,2",
        },
      },
      {
        sequenceNumber: 55,
        eventType: "EndTurn",
        userId: "p2",
        payload: {
          type: "EndTurn",
          playerId: "p2",
        },
      },
      {
        sequenceNumber: 56,
        eventType: "Move",
        userId: "p1",
        payload: {
          type: "Move",
          playerId: "p1",
          from: "-1,1",
          to: "-1,0",
        },
      },
      {
        sequenceNumber: 57,
        eventType: "Attack",
        userId: "p1",
        payload: {
          type: "Attack",
          playerId: "p1",
          from: "-2,3",
          target: "-2,2",
          attackerElement: "water",
          defenderElement: "fire",
          advance: true,
          attackerUseBastion: false,
          defenderUseBastion: false,
        },
      },
      {
        sequenceNumber: 58,
        eventType: "EndTurn",
        userId: "p1",
        payload: {
          type: "EndTurn",
          playerId: "p1",
        },
      },
      {
        sequenceNumber: 59,
        eventType: "Move",
        userId: "p2",
        payload: {
          type: "Move",
          playerId: "p2",
          from: "2,-2",
          to: "2,-1",
        },
      },
      {
        sequenceNumber: 60,
        eventType: "Move",
        userId: "p2",
        payload: {
          type: "Move",
          playerId: "p2",
          from: "2,-1",
          to: "1,0",
        },
      },
      {
        sequenceNumber: 61,
        eventType: "EndTurn",
        userId: "p2",
        payload: {
          type: "EndTurn",
          playerId: "p2",
        },
      },
      {
        sequenceNumber: 62,
        eventType: "Deploy",
        userId: "p1",
        payload: {
          type: "Deploy",
          playerId: "p1",
          to: "-2,3",
        },
      },
      {
        sequenceNumber: 63,
        eventType: "Move",
        userId: "p1",
        payload: {
          type: "Move",
          playerId: "p1",
          from: "-1,0",
          to: "0,-1",
        },
      },
      {
        sequenceNumber: 64,
        eventType: "EndTurn",
        userId: "p1",
        payload: {
          type: "EndTurn",
          playerId: "p1",
        },
      },
      {
        sequenceNumber: 65,
        eventType: "Move",
        userId: "p2",
        payload: {
          type: "Move",
          playerId: "p2",
          from: "1,0",
          to: "0,1",
        },
      },
      {
        sequenceNumber: 66,
        eventType: "Move",
        userId: "p2",
        payload: {
          type: "Move",
          playerId: "p2",
          from: "0,1",
          to: "-1,2",
        },
      },
      {
        sequenceNumber: 67,
        eventType: "EndTurn",
        userId: "p2",
        payload: {
          type: "EndTurn",
          playerId: "p2",
        },
      },
      {
        sequenceNumber: 68,
        eventType: "Attack",
        userId: "p1",
        payload: {
          type: "Attack",
          playerId: "p1",
          from: "0,-1",
          target: "1,-2",
          attackerElement: "water",
          defenderElement: "ice",
          advance: true,
          attackerUseBastion: false,
          defenderUseBastion: false,
        },
      },
      {
        sequenceNumber: 69,
        eventType: "Attack",
        userId: "p1",
        payload: {
          type: "Attack",
          playerId: "p1",
          from: "-2,3",
          target: "-1,2",
          attackerElement: "plant",
          defenderElement: "stone",
          advance: true,
          attackerUseBastion: false,
          defenderUseBastion: false,
        },
      },
      {
        sequenceNumber: 70,
        eventType: "EndTurn",
        userId: "p1",
        payload: {
          type: "EndTurn",
          playerId: "p1",
        },
      },
      {
        sequenceNumber: 71,
        eventType: "Attack",
        userId: "p2",
        payload: {
          type: "Attack",
          playerId: "p2",
          from: "-1,2",
          target: "-2,3",
          attackerElement: "stone",
          defenderElement: "ice",
          advance: true,
          attackerUseBastion: false,
          defenderUseBastion: false,
        },
      },
      {
        sequenceNumber: 72,
        eventType: "Attack",
        userId: "p2",
        payload: {
          type: "Attack",
          playerId: "p2",
          from: "-1,2",
          target: "-2,2",
          attackerElement: "water",
          defenderElement: "fire",
          advance: true,
          attackerUseBastion: false,
          defenderUseBastion: false,
        },
      },
      {
        sequenceNumber: 73,
        eventType: "EndTurn",
        userId: "p2",
        payload: {
          type: "EndTurn",
          playerId: "p2",
        },
      },
      {
        sequenceNumber: 74,
        eventType: "Attack",
        userId: "p1",
        payload: {
          type: "Attack",
          playerId: "p1",
          from: "-2,2",
          target: "-1,2",
          attackerElement: "fire",
          defenderElement: "plant",
          advance: true,
          attackerUseBastion: false,
          defenderUseBastion: false,
        },
      },
      {
        sequenceNumber: 75,
        eventType: "Attack",
        userId: "p1",
        payload: {
          type: "Attack",
          playerId: "p1",
          from: "-1,3",
          target: "-1,2",
          attackerElement: "stone",
          defenderElement: "ice",
          advance: true,
          attackerUseBastion: false,
          defenderUseBastion: false,
        },
      },
      {
        sequenceNumber: 76,
        eventType: "EndTurn",
        userId: "p1",
        payload: {
          type: "EndTurn",
          playerId: "p1",
        },
      },
      {
        sequenceNumber: 77,
        eventType: "Move",
        userId: "p2",
        payload: {
          type: "Move",
          playerId: "p2",
          from: "3,-2",
          to: "2,-1",
        },
      },
      {
        sequenceNumber: 78,
        eventType: "Move",
        userId: "p2",
        payload: {
          type: "Move",
          playerId: "p2",
          from: "2,-1",
          to: "1,0",
        },
      },
      {
        sequenceNumber: 79,
        eventType: "EndTurn",
        userId: "p2",
        payload: {
          type: "EndTurn",
          playerId: "p2",
        },
      },
      {
        sequenceNumber: 80,
        eventType: "Move",
        userId: "p1",
        payload: {
          type: "Move",
          playerId: "p1",
          from: "-2,2",
          to: "-2,1",
        },
      },
      {
        sequenceNumber: 81,
        eventType: "Move",
        userId: "p1",
        payload: {
          type: "Move",
          playerId: "p1",
          from: "-2,1",
          to: "-1,0",
        },
      },
      {
        sequenceNumber: 82,
        eventType: "EndTurn",
        userId: "p1",
        payload: {
          type: "EndTurn",
          playerId: "p1",
        },
      },
      {
        sequenceNumber: 83,
        eventType: "Move",
        userId: "p2",
        payload: {
          type: "Move",
          playerId: "p2",
          from: "1,0",
          to: "0,1",
        },
      },
      {
        sequenceNumber: 84,
        eventType: "Attack",
        userId: "p2",
        payload: {
          type: "Attack",
          playerId: "p2",
          from: "0,1",
          target: "-1,2",
          attackerElement: "stone",
          defenderElement: "water",
          advance: true,
          attackerUseBastion: false,
          defenderUseBastion: false,
        },
      },
      {
        sequenceNumber: 85,
        eventType: "EndTurn",
        userId: "p2",
        payload: {
          type: "EndTurn",
          playerId: "p2",
        },
      },
      {
        sequenceNumber: 86,
        eventType: "Move",
        userId: "p1",
        payload: {
          type: "Move",
          playerId: "p1",
          from: "-1,0",
          to: "0,-1",
        },
      },
      {
        sequenceNumber: 87,
        eventType: "Attack",
        userId: "p1",
        payload: {
          type: "Attack",
          playerId: "p1",
          from: "0,-1",
          target: "1,-2",
          attackerElement: "fire",
          defenderElement: "ice",
          advance: true,
          attackerUseBastion: false,
          defenderUseBastion: false,
        },
      },
      {
        sequenceNumber: 88,
        eventType: "EndTurn",
        userId: "p1",
        payload: {
          type: "EndTurn",
          playerId: "p1",
        },
      },
      {
        sequenceNumber: 89,
        eventType: "Attack",
        userId: "p2",
        payload: {
          type: "Attack",
          playerId: "p2",
          from: "2,-3",
          target: "1,-2",
          attackerElement: "ice",
          defenderElement: "stone",
          advance: true,
          attackerUseBastion: false,
          defenderUseBastion: false,
        },
      },
      {
        sequenceNumber: 90,
        eventType: "Attack",
        userId: "p2",
        payload: {
          type: "Attack",
          playerId: "p2",
          from: "2,-3",
          target: "1,-2",
          attackerElement: "fire",
          defenderElement: "plant",
          advance: true,
          attackerUseBastion: false,
          defenderUseBastion: false,
        },
      },
      {
        sequenceNumber: 91,
        eventType: "EndTurn",
        userId: "p2",
        payload: {
          type: "EndTurn",
          playerId: "p2",
        },
      },
      {
        sequenceNumber: 92,
        eventType: "Attack",
        userId: "p1",
        payload: {
          type: "Attack",
          playerId: "p1",
          from: "-1,2",
          target: "0,1",
          attackerElement: "plant",
          defenderElement: "water",
          advance: true,
          attackerUseBastion: false,
          defenderUseBastion: false,
        },
      },
      {
        sequenceNumber: 93,
        eventType: "Move",
        userId: "p1",
        payload: {
          type: "Move",
          playerId: "p1",
          from: "-3,3",
          to: "-2,2",
        },
      },
      {
        sequenceNumber: 94,
        eventType: "EndTurn",
        userId: "p1",
        payload: {
          type: "EndTurn",
          playerId: "p1",
        },
      },
      {
        sequenceNumber: 95,
        eventType: "EndTurn",
        userId: "p2",
        payload: {
          type: "EndTurn",
          playerId: "p2",
        },
      },
      {
        sequenceNumber: 96,
        eventType: "Attack",
        userId: "p1",
        payload: {
          type: "Attack",
          playerId: "p1",
          from: "-1,2",
          target: "0,1",
          attackerElement: "ice",
          defenderElement: "stone",
          advance: true,
          attackerUseBastion: false,
          defenderUseBastion: false,
        },
      },
      {
        sequenceNumber: 97,
        eventType: "Attack",
        userId: "p1",
        payload: {
          type: "Attack",
          playerId: "p1",
          from: "-1,2",
          target: "0,1",
          attackerElement: "fire",
          defenderElement: "plant",
          advance: true,
          attackerUseBastion: false,
          defenderUseBastion: false,
        },
      },
      {
        sequenceNumber: 98,
        eventType: "EndTurn",
        userId: "p1",
        payload: {
          type: "EndTurn",
          playerId: "p1",
        },
      },
      {
        sequenceNumber: 99,
        eventType: "Attack",
        userId: "p2",
        payload: {
          type: "Attack",
          playerId: "p2",
          from: "2,-3",
          target: "1,-2",
          attackerElement: "plant",
          defenderElement: "water",
          advance: true,
          attackerUseBastion: false,
          defenderUseBastion: false,
        },
      },
      {
        sequenceNumber: 100,
        eventType: "Deploy",
        userId: "p2",
        payload: {
          type: "Deploy",
          playerId: "p2",
          to: "2,-3",
        },
      },
      {
        sequenceNumber: 101,
        eventType: "EndTurn",
        userId: "p2",
        payload: {
          type: "EndTurn",
          playerId: "p2",
        },
      },
      {
        sequenceNumber: 102,
        eventType: "Deploy",
        userId: "p1",
        payload: {
          type: "Deploy",
          playerId: "p1",
          to: "-3,3",
        },
      },
      {
        sequenceNumber: 103,
        eventType: "Move",
        userId: "p1",
        payload: {
          type: "Move",
          playerId: "p1",
          from: "0,1",
          to: "1,0",
        },
      },
      {
        sequenceNumber: 104,
        eventType: "EndTurn",
        userId: "p1",
        payload: {
          type: "EndTurn",
          playerId: "p1",
        },
      },
      {
        sequenceNumber: 105,
        eventType: "Move",
        userId: "p2",
        payload: {
          type: "Move",
          playerId: "p2",
          from: "1,-2",
          to: "1,-1",
        },
      },
      {
        sequenceNumber: 106,
        eventType: "Move",
        userId: "p2",
        payload: {
          type: "Move",
          playerId: "p2",
          from: "1,-1",
          to: "2,-1",
        },
      },
      {
        sequenceNumber: 107,
        eventType: "EndTurn",
        userId: "p2",
        payload: {
          type: "EndTurn",
          playerId: "p2",
        },
      },
      {
        sequenceNumber: 108,
        eventType: "Move",
        userId: "p1",
        payload: {
          type: "Move",
          playerId: "p1",
          from: "1,0",
          to: "1,-1",
        },
      },
      {
        sequenceNumber: 109,
        eventType: "Move",
        userId: "p1",
        payload: {
          type: "Move",
          playerId: "p1",
          from: "1,-1",
          to: "1,-2",
        },
      },
      {
        sequenceNumber: 110,
        eventType: "EndTurn",
        userId: "p1",
        payload: {
          type: "EndTurn",
          playerId: "p1",
        },
      },
      {
        sequenceNumber: 111,
        eventType: "Attack",
        userId: "p2",
        payload: {
          type: "Attack",
          playerId: "p2",
          from: "2,-3",
          target: "1,-2",
          attackerElement: "fire",
          defenderElement: "stone",
          advance: true,
          attackerUseBastion: false,
          defenderUseBastion: false,
        },
      },
      {
        sequenceNumber: 112,
        eventType: "Attack",
        userId: "p2",
        payload: {
          type: "Attack",
          playerId: "p2",
          from: "2,-3",
          target: "1,-2",
          attackerElement: "ice",
          defenderElement: "plant",
          advance: true,
          attackerUseBastion: false,
          defenderUseBastion: false,
        },
      },
      {
        sequenceNumber: 113,
        eventType: "EndTurn",
        userId: "p2",
        payload: {
          type: "EndTurn",
          playerId: "p2",
        },
      },
      {
        sequenceNumber: 114,
        eventType: "Move",
        userId: "p1",
        payload: {
          type: "Move",
          playerId: "p1",
          from: "-2,2",
          to: "-2,1",
        },
      },
      {
        sequenceNumber: 115,
        eventType: "Move",
        userId: "p1",
        payload: {
          type: "Move",
          playerId: "p1",
          from: "-2,1",
          to: "-1,0",
        },
      },
      {
        sequenceNumber: 116,
        eventType: "EndTurn",
        userId: "p1",
        payload: {
          type: "EndTurn",
          playerId: "p1",
        },
      },
      {
        sequenceNumber: 117,
        eventType: "Deploy",
        userId: "p2",
        payload: {
          type: "Deploy",
          playerId: "p2",
          to: "2,-3",
        },
      },
      {
        sequenceNumber: 118,
        eventType: "Move",
        userId: "p2",
        payload: {
          type: "Move",
          playerId: "p2",
          from: "2,-1",
          to: "1,0",
        },
      },
      {
        sequenceNumber: 119,
        eventType: "EndTurn",
        userId: "p2",
        payload: {
          type: "EndTurn",
          playerId: "p2",
        },
      },
    ],
    notes: [
      "Generated from the self-play sim: seed 1, greedy vs greedy.",
      "Result: timeout (p2) — 41 turns, 34 combats.",
    ],
  },
};
